import React, { Component } from 'react';
import moment from 'moment';
import { Row, Col, Typography, Input, Empty, Button, Select, Icon } from 'antd';
import { connect } from 'react-redux';

import { EditIcon, RemoveIcon } from 'components/Icons';
import SpinBox from 'components/SpinBox';
import * as API from 'utils/api';
import { notifyApiError, notifyInfo } from 'utils/notification';
import { ROLES_DIVISIONS } from 'layout/roles';
import { getClientId } from 'layout/roles';
import { USER_EDIT_NAV } from 'layout/navigate_const';
import { DeleteUserModal } from 'components/Modal/DeleteUserModal';

import { getPermissionsBySection, USERS_PERMISSIONS_NAME } from 'permissions';

import './MyUsers.scss';

const { Search } = Input;
const { Title, Text } = Typography;
const { Option } = Select;

class MyUsers extends Component {
  constructor(props) {
    super(props);

    // Permissions
    const { USERS_PERMISSIONS } = getPermissionsBySection({
      roles: this.props.roles,
      permissions: [USERS_PERMISSIONS_NAME],
    });
    // end permissions

    this.state = {
      pageIndex: 0,
      showModal: false,
      usersData: [],
      totalCount: 0,
      selectedUser: {},
      searchQuery: '',
      querySearched: false,
      loading: true,
      loadingTitle: 'Loading...',
      userType_list: [],
      userTypeFilter: [],
      USERS_PERMISSIONS,
    };

    this.handlePagination = this.handlePagination.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleEditUser = this.handleEditUser.bind(this);
    this.handleDeleteUser = this.handleDeleteUser.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
  }

  async componentDidMount() {
    try {
      this.handleSearch({ activeLoading: false });

      const getRoles = await API.getNurseRoles(false);
      const onlyRoleClient = getRoles.roles.filter(item => ROLES_DIVISIONS.ALL_CLIENT.includes(item.name));

      this.setState({ userType_list: onlyRoleClient });
    } catch (e) {
      notifyApiError(e);
    } finally {
      this.setState({ loading: false });
    }
  }

  handlePagination(pageIndex) {
    this.setState(
      {
        pageIndex: pageIndex,
      },
      () => this.handleSearch()
    );
  }

  handleCloseModal() {
    this.setState({
      showModal: false,
    });
  }

  handleOpenModal(item) {
    this.setState({
      showModal: true,
      selectedUser: item,
    });
  }

  handleEditUser(item) {
    this.props.history.push(USER_EDIT_NAV.path, { data: item });
  }

  async handleDeleteUser(item) {
    this.setState({
      showModal: false,
      loading: true,
      loadingTitle: 'Deleting...',
    });

    try {
      await API.deleteUserSynchronised(item.id);
      await API.deleteUser(item.email);

      notifyInfo('User was deleted');

      this.setState({
        usersData: this.state.usersData.filter(user => user.id !== item.id),
        // totalCount: this.state.totalCount - 1,
      });
    } catch (e) {
      notifyApiError(e);
    } finally {
      this.setState({ loading: false });
    }
  }

  async handleSearch({ activeLoading = true, userTypeFilter = this.state.userTypeFilter } = {}) {
    if (activeLoading) this.setState({ loading: true, loadingTitle: 'Loading...' });

    const idClient = getClientId(this.props.roles);

    let { searchQuery } = this.state;
    this.setState({ loading: true, loadingTitle: 'Loading' });

    searchQuery = encodeURIComponent(searchQuery.trim());
    try {
      const res = await API.getUsersByClient({ idClient, searchQuery, filterType: userTypeFilter.join(',') });

      this.setState({
        usersData: res.rows,
        // totalCount: res.total_count,
      });
    } catch (e) {
      notifyApiError(e);
    } finally {
      this.setState({ loading: false });
    }
  }

  handleFilter({ field, value }) {
    const { userTypeFilter } = this.state;
    const search = {
      userTypeFilter,
      [field]: value,
    };

    this.setState({ [field]: value });
    this.handleSearch({ userTypeFilter: search.userTypeFilter });
  }

  render() {
    const { usersData, showModal, selectedUser, loading, loadingTitle, userType_list, USERS_PERMISSIONS } = this.state;
    const { userInfo } = this.props;

    return (
      <Row className="users-container">
        <Row type="flex" align="middle" className="header header_filter">
          <Col className="title">
            <Title level={4} className="title-text">
              My Users
            </Title>
          </Col>
          <Col className="search">
            <Search
              placeholder="Search..."
              className="search-box"
              onSearch={async value => {
                await this.setState({ searchQuery: value, pageIndex: 0 });
                this.handleSearch();
              }}
            />

            <div className="search_filter">
              <Select
                showSearch
                placeholder="User Type"
                optionFilterProp="children"
                className="dropdown"
                mode="multiple"
                onChange={value => this.handleFilter({ field: 'userTypeFilter', value })}
                suffixIcon={<Icon type="caret-down" style={{ color: 'black' }} theme="filled" />}>
                {userType_list.map(role => {
                  return (
                    <Option key={role.id} value={role.id}>
                      {role.name}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </Col>
          <Col className="pagination" />
          <Col className="add-button">
            {USERS_PERMISSIONS.create && (
              <Button type="primary" className="green-btn" onClick={() => this.props.history.push('/app/users/add')}>
                Add New User
              </Button>
            )}
          </Col>
        </Row>
        <Row type="flex" className="table-header">
          <Col xs={9}>User</Col>
          <Col xs={3}>User Type</Col>
          <Col xs={5}>Law Firm</Col>
          <Col xs={5}>Date Added</Col>
          {USERS_PERMISSIONS.edit && (
            <Col xs={2} style={{ textAlign: 'right' }}>
              Actions
            </Col>
          )}
        </Row>
        <Row className="table-content">
          <SpinBox loading={loading} title={loadingTitle}>
            {usersData.length > 0 ? (
              <Row>
                {usersData.map((item, index) => {
                  const isUserCurrentUser = item.id === userInfo.username;

                  return (
                    <Row key={index} className="record" gutter={[16, 16]}>
                      <Col xs={9}>
                        <Text className="wrapped-text user-name">
                          <span className="user-name-name">{item.given_name + ' ' + item.family_name}</span>
                          <span>{item?.email || ''}</span>
                        </Text>
                      </Col>
                      <Col xs={3}>
                        <Text className="wrapped-text">{item?.company_info || ''}</Text>
                      </Col>
                      <Col xs={5}>
                        <Text>{item?.role_name || ''}</Text>
                      </Col>
                      <Col xs={5}>
                        <Text>{moment(item.createdAt).format('MMMM DD, YYYY')}</Text>
                      </Col>

                      {USERS_PERMISSIONS.edit && (
                        <Col xs={2} className="actions">
                          <EditIcon className="icon" onClick={() => this.handleEditUser(item)} />

                          {USERS_PERMISSIONS.delete && (
                            <RemoveIcon
                              className={`icon ${isUserCurrentUser ? 'disabled' : ''}`}
                              onClick={() => (!isUserCurrentUser ? this.handleOpenModal(item) : null)}
                            />
                          )}
                        </Col>
                      )}
                    </Row>
                  );
                })}
              </Row>
            ) : (
              <Empty
                description={loading ? false : 'No Data'}
                image={!loading ? Empty.PRESENTED_IMAGE_SIMPLE : null}
                className="empty-icon"
              />
            )}
          </SpinBox>
        </Row>

        <DeleteUserModal
          open={showModal}
          onClose={this.handleCloseModal}
          onDelete={() => this.handleDeleteUser(selectedUser)}
          data={selectedUser}
        />
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  roles: state.auth.roles,
  userInfo: state.auth.userInfo,
});

export default connect(mapStateToProps, null)(MyUsers);
